import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function c(s, a, m, f, i, p) {
  return o(), e("svg", n, a[0] || (a[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF3AB",
        d: "M37.749 23.252c4.002 4.003 4.002 10.494 0 14.496-4.004 4.003-10.494 4.003-14.497 0-4.003-4.002-4.003-10.493 0-14.496s10.493-4.003 14.497 0"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M22.368 22.369c4.491-4.492 11.773-4.492 16.264 0 4.49 4.49 4.49 11.773 0 16.263-4.491 4.49-11.773 4.49-16.263 0-4.492-4.49-4.492-11.773 0-16.263Zm14.287 1.565a9 9 0 0 0-12.519.202 9.001 9.001 0 1 0 12.931.21l-.202-.21-.21-.202ZM30.5 8.75c.647 0 1.18.492 1.244 1.122l.006.128v4.1a1.25 1.25 0 0 1-2.493.128l-.007-.128V10c0-.69.56-1.25 1.25-1.25Zm0 36.9c.647 0 1.18.492 1.244 1.122l.006.128V51a1.25 1.25 0 0 1-2.493.128L29.25 51v-4.1c0-.69.56-1.25 1.25-1.25Zm13.61-30.527a1.25 1.25 0 0 1 1.858 1.666l-.09.101-1.456 1.456a1.25 1.25 0 0 1-1.86-1.666l.092-.102 1.455-1.455Zm-27.532 27.53a1.25 1.25 0 0 1 1.86 1.667l-.092.101-1.456 1.456a1.25 1.25 0 0 1-1.858-1.666l.09-.102 1.456-1.455ZM51 29.25a1.25 1.25 0 0 1 .128 2.494L51 31.75h-4.1a1.25 1.25 0 0 1-.128-2.493l.128-.007H51Zm-36.9 0a1.25 1.25 0 0 1 .128 2.494l-.128.006H10a1.25 1.25 0 0 1-.128-2.493L10 29.25h4.1Zm28.554 13.404a1.25 1.25 0 0 1 1.666-.092l.102.092 1.455 1.455a1.25 1.25 0 0 1-1.666 1.859l-.102-.091-1.455-1.456a1.25 1.25 0 0 1 0-1.767ZM15.123 15.123a1.25 1.25 0 0 1 1.666-.091l.101.09 1.456 1.456a1.25 1.25 0 0 1-1.666 1.86l-.102-.092-1.455-1.456a1.25 1.25 0 0 1 0-1.767Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ t(r, [["render", c]]);
export {
  _ as default
};
